import React from "react";
import Icon from "components/Icon";
import styles from "./index.module.scss";

const Footer = () => {
  const dialogCopyright = () => {
    alert(
      "版權聲明：茲就南一書局企業股份有限公司（以下簡稱本公司）所提供之著作（包括但不限於文字、攝影、圖形、錄音、視聽暨其以Word或PDF等數位形式出版產品，及未來以各種形式發表之產品或內容），其著作財產權均歸屬於本公司所有或經具有合法權源之人授權使用，並受著作權法保護。各級學校及其擔任教學之人，基於為學校授課目的之必要範圍內，得在不逾越著作權法第46條、第46之1條及第65條規定下，合理使用本公司已公開發表之著作，但於利用時亦應以合理方式明示其出處。"
    );
  };

  return (
    <footer>
      <div className={styles.container}>
        <div className={styles.connectionInfo}>
          <h5 className={styles.connectionUs}>聯繫我們</h5>
          <div className={styles.connectionInfoButtons}>
            <div className={styles.button}>
              <a
                href="https://s.nani.cool/ebookforms"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon type="text" name="envelope" />
                <div>意見回饋</div>
              </a>
            </div>
            <div className={styles.button}>
              <a
                href="https://cdn.nani.cool/download/%E5%8D%97%E4%B8%80%E9%81%A0%E7%AB%AF%E9%80%A3%E7%B7%9A.exe"
                download
              >
                <Icon type="text" name="tools" />
                <div>遠端連線</div>
              </a>
            </div>
          </div>
          <div className={styles.command}>
            <span>
              為了讓您獲得最佳瀏覽體驗，建議您使用的瀏覽器軟體為：IE
              Edge、Google Chrome 或 Firefox。
            </span>
            <span>
              如使用IE瀏覽器瀏覽本網站，可能會發生部分網頁的呈現會有破圖或版面跑版的情況，亦可能導致某些網頁互動功能無法正確顯示與使用。
            </span>
          </div>
        </div>
        <div className={styles.bottom}>
        <div className={styles.version}>
          v{process.env.REACT_APP_VERSION || "0.0.1"}
        </div>
          <div>南一教育股份有限公司 Copyright ©</div>
          <div
            className={styles.copyrightBtn}
            onClick={() => dialogCopyright()}
          >
            版權聲明
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
